import { faArrowRight, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Component } from "react";
import { Container, NavLink} from "reactstrap";
import NavTab from "../../../components/common/global_layout/navTab";
import {connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import ClientDetails from "../../../components/common/Visas/clientDetails";
import LBdescription from "../../../components/common/Vols/LBdescription";
import Footer from "../../../components/common/global_layout/footer";
import ReserveBtn from "../../../components/common/Vols/reserveBtn";



class DetailsVisa extends Component {
    
    render() { 
        return (
          <>
            <Container className="visa__details">
              <NavTab display="none" />
              
               
                  <Container className="linksContainer d-none d-md-flex justify-content-start p-0">
                    <NavLink className="pageLinks" to="/">
                      Ghurfaty
                    </NavLink>
                    <FontAwesomeIcon
                      className="align-self-center faChevron"
                      icon={faChevronRight}
                    ></FontAwesomeIcon>
                    <NavLink className="pageLinks" to="/">
                      Visas
                    </NavLink>
                    <FontAwesomeIcon
                      className="align-self-center faChevron"
                      icon={faChevronRight}
                    ></FontAwesomeIcon>
                    <NavLink className="pageLinks" to="/">
                      e-Visa
                    </NavLink>
                  </Container>
                  <Container className="d-flex flex-column flex-md-row">
                    <div className=" col-lg-6 p-0 pr-lg-2">
                        
                          <p
                            id="typeService"
                            className="mt-1  justify-content-start"
                          >
                            VISA
                          </p>
                          <div className="d-flex justify-content-between align-items-end">
                            <span className="title-detail mb-1">e-Visa Turquie</span>
                            <img src="/imgs/Visa/turkey.png" className="visa__flag__mobile d-block d-md-none" alt="turkey" />
                          </div>
                    
                          <hr style={{ width: "100%" }} />
                          <p className="ft-collapse">
                            e-Visa Turquie pour les personnes agées entre 18 et 35
                            ans
                          </p>
                    
                        <div className="p-0 flex-column mt-3 col-12  mb-3 mb-lg-0">
                            <ClientDetails />
                        </div>
                        <div className="row p-0 d-flex justify-content-between justify-content-sm-around align-items-center mt-5 mb-4">
                          <div className="d-flex flex-column align-items-center ml-4 ml-md-5">
                            <span className="visa__allerRet_txt">Départ</span>
                            <span className="visa__allerRet_nbr">18</span>
                            <span className="visa__allerRet_txt">Aout</span>
                          </div>
                          <FontAwesomeIcon icon={faArrowRight} className="visa__arrow"/>
                          <div className="d-flex flex-column align-items-center mr-4 mr-md-5">
                            <span className="visa__allerRet_txt">Retour</span>
                            <span className="visa__allerRet_nbr">29</span>
                            <span className="visa__allerRet_txt">Septembre</span>
                          </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-6 p-0 pl-lg-2">
                      <div className=" pl-md-5  d-flex justify-content-end">
                        <img src="/imgs/Visa/turkey.png" className="visa__flag d-none d-md-block" alt="turkey" />
                      </div>
                    
                      <div className="d-flex flex-column col-12 pl-0  pr-0 pl-md-5 mt-3">
                        <LBdescription />
                      </div>
                      <div className=" pr-0  pl-md-5 mt-5">
                        <div className="volActions__actionsVol d-flex flex-column mb-4">
                           <ReserveBtn color="rgb(0, 167, 6)" height="40px" content="Contacter l'annonceur" icon="/imgs/resrervationIcons/annoncer-contacts.svg" event="contact" />
                           <ReserveBtn color="#37296a" height="40px" content="Reserver maintenant" icon="/imgs/resrervationIcons/reserverMaintenant.svg"  event="reserve"/>
                        </div>
                      </div>
                    </div>

                    
                  </Container>
             
               
                      
               

            </Container>
            <Footer />
          </>
        );
    }
}
 

function mapStateToProps(state) {
  return {
     state
  }
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(DetailsVisa));